import { baseApi } from "../BaseUrl";

const authApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        loginUser: builder.mutation({
            query: (data) => {
                return {
                    url: 'auth/sign-in',
                    method: 'POST',
                    body: data
                }
            },
            invalidatesTags: ['auth', 'category']
        }),
        forgetPassword: builder.mutation({
            query: (data) => {
                return {
                    url: 'auth/send-verify-email',
                    method: 'POST',
                    body: data
                }
            },
            invalidatesTags: ['auth']
        }),
        verifyCode: builder.mutation({
            query: (data) => {
                return {
                    url: 'auth/verify-code',
                    method: 'POST',
                    body: data
                }
            },
            invalidatesTags: ['auth']
        }),
        resetPassword: builder.mutation({
            query: (data) => {
                return {
                    url: 'auth/reset-password',
                    method: 'POST',
                    body: data,
                    headers: {
                        Authorization: `Bearer ${JSON.parse((localStorage.getItem('accessToken'))) || ""}`,
                    }
                }
            },
            invalidatesTags: ['auth']
        }),
        changePassword: builder.mutation({
            query: (data) => {
                return {
                    url: 'auth/change-password',
                    method: 'PATCH',
                    body: data
                }
            },
            invalidatesTags: ['auth']
        }),
        updateUser: builder.mutation({
            query: (data) => {
                return {
                    url: 'auth/update-user',
                    method: 'PATCH',
                    body: data,
                }
            },
            invalidatesTags: ['auth']
        }),
        updateDoctor: builder.mutation({
            query: ({ id, data }) => {
                return {
                    url: `auth/update-doctor/${id}`,
                    method: 'PATCH',
                    body: data,
                }
            },
            invalidatesTags: ['auth']
        }),
        getProfile: builder.query({
            query: () => ({
                url: 'auth/profile',
                method: 'GET',
            }),
            providesTags: ['auth'],
        }),
        logout: builder.mutation({
            query: () => ({
                url: 'auth/logout',
                method: 'POST',
            }),
            invalidatesTags: ['auth'],
        }),
    })
})
export const {
    useLoginUserMutation,
    useForgetPasswordMutation,
    useVerifyCodeMutation,
    useResetPasswordMutation,
    useChangePasswordMutation,
    useUpdateUserMutation,
    useUpdateDoctorMutation,
    useGetProfileQuery,
    useLogoutMutation,
} = authApi